$bog_pazzle_board_tile $rise_drag_view
	rows 1
	columns 1
	piece 0
	slot 0
	image_uri \
	playable false
	locked false
	selected false
	label \
	sub /
		<= Number $mol_text
			text <= label
